export const formatBadgeCount = (count: number) => (count > 99 ? '99+' : `${count}`);
